import { createSelector } from 'utils/app.util';

export const getWellProjectsFromState = createSelector(
  (state) => state.getIn(['wells', 'projects', 'data', 'projects']),
  (projects) => projects,
);
